import { useMemo } from 'react'

import { getImagePath } from '../helpers'

export const useMemoImage = (
  image: Parameters<typeof getImagePath>[0],
): string | undefined => useMemo(() => getImagePath(image), [image])
